export default __webpack_public_path__ + "8169508bf58f8bd92ad8a768ede68a18.ttf";